import { RichTextRenderer } from "./RichTextRenderer";
import Cta from "@components/Cta";
import styles from "../styles/RichText.module.css";

const List = ({ children, type }) => {
  if (type === "bullet") {
    return <ul className={styles.list}>{children}</ul>;
  }
  return <ol className={styles.list}>{children}</ol>;
};

const ListItem = ({ children }) => <li className={styles.listItem}>{children}</li>;

export const serializers = {
  types: {
    block: RichTextRenderer,
  },
  list: List,
  listItem: ListItem,
  marks: {
    internalLink: ({ mark, children }) => {
      const link = {
        title: children.length ? children[0] : children,
        handle: mark.handle,
        slug: mark.slug,
        type: mark.type,
        productGroup: mark.productGroup,
        id: mark.id,
      };

      return <Cta navLink={link} />;
    },
    link: ({ mark, children }) => {
      // Read https://css-tricks.com/use-target_blank/
      const { blank, href } = mark;
      return blank ? (
        <a href={href} target="_blank" rel="noopener noreferrer">
          {children}
        </a>
      ) : (
        <a href={href}>{children}</a>
      );
    },
  },
};
